import React, { useMemo } from 'react';
import MediaTile from './MediaTile';
import { isSignIn } from '../helpers/helpers';
import { CHILD_LETTER_CODE } from "../helpers/mediaData";

function Year (props) {
  const { year, mediaData, handleClick, getIsVideo, getMediaFormat, childData } = props;
  const isAuth = isSignIn();

  const allMediaKeys = useMemo(() => {
    // Important Business Logic To Not Show Child Letters ( CCS ) If Not Auth
    const isCanceledReason = /rflgrouping=canceled/i.test(window.location.search);
    const [ccsMediaKeys, restMediaKeys] = Object.keys(mediaData).reduce(([filteredMedia, otherMedia], mediaKey) => {
      const mediaItem = mediaData[mediaKey] 
        && mediaData[mediaKey].original 
        && Object.values(mediaData[mediaKey].original)[0] || {};

      // Is CCS Media Content Type
      const isCCSMedia = mediaItem 
        && mediaItem.contentTypeCode 
        && mediaItem.contentTypeCode.toUpperCase() === CHILD_LETTER_CODE || false;

      // Separate Types
      if (isCCSMedia) {
        filteredMedia.push(mediaKey);
      } else {
        otherMedia.push(mediaKey);
      }

      // Combine then on to next item
      return [filteredMedia, otherMedia];
    }, [[], []]);

    // If Not Auth Then Return Rest Of Media Without CCS
    if (!isAuth || isCanceledReason) {
      return [...restMediaKeys];
    }

    // If Auth Sort CCS Media To Top Of Media List
    return [...ccsMediaKeys, ...restMediaKeys];
  }, [mediaData, year, isAuth, childData]);

  // If There Are No Items In Year After Filter, Then Do Not Render It
  if (!allMediaKeys.length) {
    return null;
  }

  return (
    <div className="year__wrapper">
      <h2 className="child-gallery__title gallery__title">
        {year}
      </h2>
      <div className="tile__wrapper">
        {
          allMediaKeys.map(key => 
            (
              <MediaTile 
                key={key} 
                media={mediaData[key]} 
                handleClick={handleClick} 
                getIsVideo={getIsVideo} 
                getMediaFormat={getMediaFormat}
                childData={childData}
              />
            )
          )
        }
      </div>
    </div>
  );
}

export default Year;

